/**
 * No-op audio engine for headless sims, SSR, or disabled audio.
 * Never constructs AudioContext.
 */

import type { AudioEvent, ProclaimKaraokeDriver } from "./events";
import { linearKaraokeDriver } from "./events";
import type { AudioFrameInput } from "./frame";
import {
  DEFAULT_AUDIO_SETTINGS,
  mergeAudioSettings,
  type AudioBusId,
  type AudioSettings,
} from "./settings";
import type { AudioEngine } from "./types";

export function createNullEngine(
  initial: AudioSettings = DEFAULT_AUDIO_SETTINGS,
): AudioEngine {
  let settings: AudioSettings = { ...initial };
  let disposed = false;

  return {
    kind: "null",
    async resume() {},
    async suspend() {},
    async preload(_ids: string[]) {},
    emit(_e: AudioEvent) {},
    tick(_frame: AudioFrameInput, _dt: number) {},
    setBusVolume(bus: AudioBusId, v: number) {
      if (disposed) return;
      if (bus === "master") {
        settings = mergeAudioSettings(settings, { master: v });
      } else {
        settings = mergeAudioSettings(settings, { [bus]: v });
      }
    },
    getSettings() {
      return { ...settings };
    },
    applySettings(partial: Partial<AudioSettings>) {
      if (disposed) return;
      settings = mergeAudioSettings(settings, partial);
    },
    createKaraokeDriver(): ProclaimKaraokeDriver {
      return linearKaraokeDriver();
    },
    async playVerseVo(_verseId: string) {
      return false;
    },
    stopVerseVo() {},
    isVerseVoPlaying(_verseId?: string) {
      return false;
    },
    resetMission() {},
    dispose() {
      disposed = true;
    },
  };
}
